import { render, staticRenderFns } from "./SurveyAttributes.vue?vue&type=template&id=697b733a&scoped=true&"
import script from "./SurveyAttributes.vue?vue&type=script&lang=js&"
export * from "./SurveyAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697b733a",
  null
  
)

export default component.exports